import MobileNavigation from './MobileNavigation.vue'
import FlyoutMenuTrigger from './FlyoutMenuTrigger.vue'
import FlyoutMenu from './FlyoutMenu.vue'

const navigationComponents = [
  FlyoutMenuTrigger,
  FlyoutMenu,
  MobileNavigation,
]

export default navigationComponents
